import WarpElement from '@warp-ds/elements-core';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { trackContactUs } from '../utils/pulseTrackingUtils.js';
import '@warp-ds/elements/components/button';
import { i18n } from '@lingui/core';
import { ProfileType } from '../../server/types.js';

@customElement('contact-button')
export class ContactButton extends WarpElement {
	@property({ type: String }) contactUsUrl?: string;
	@property({ type: ProfileType }) profileType?: ProfileType;

	static styles = [
		...WarpElement.styles,
		css`
			@css-placeholder-LnhuEq;
		`,
	];

	render() {
		if (!this.contactUsUrl) {
			return nothing;
		}
		return html`
			<h2 class="sr-only">
				${i18n.t({
					id: 'companyProfile.contactHeading',
					message: 'Contact the seller',
					comment: 'Screen-reader-only heading for the contact section',
				})}
			</h2>
			<w-button
				href=${this.contactUsUrl}
				variant="primary"
				full-width
				@click="${() => trackContactUs(this.profileType)}"
			>
				${i18n.t({
					id: 'contact.us',
					message: 'Contact us',
				})}
			</w-button>
		`;
	}
}
